<template>
    <div>
        <el-card class="card">
            <div><el-button @click="$router.push('/dishesDamage/dishesDamageAdd')" class="myBtn">新增报损</el-button></div>
            <el-form style="margin-top:15px;margin-left:2px">
                <el-form-item label="报损日期:">
                     <el-date-picker
                     class="myData"
      v-model="dataRange"
      type="datetimerange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
    <el-button class="searchBtn">查询</el-button>
    <el-button class="resetBtn">重置</el-button>
                </el-form-item>
            </el-form>
        <el-table  max-height="400" @row-click="queryOne" :data="tableData" :border="true"
        :header-cell-style="{background:'#f59a23',color:'#fff'}"
        >
         <el-table-column align="center" label="序号" type="index"></el-table-column>
         <el-table-column align="center" label="提交日期" >
            <template slot-scope="scope">
                <span>{{scope.row.createDt | dataFormat}}</span>
            </template>
         </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" label="报损单号" prop="orderNo"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" label="报损原因" prop="reason"></el-table-column>
         <el-table-column :show-overflow-tooltip="true" align="center" label="备注" prop="remark"></el-table-column>
            </el-table>
            <div>
                 <el-pagination
      @size-change="handleSizeChangeList"
      @current-change="handleCurrentChangeList"
      :current-page="queryInfo.currPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalList">
    </el-pagination>
            </div>
            <!--  -->
            <div class="two" >
        <div class="head"> <span>商品明细</span> | <span>当前单据号</span> {{queryInfoDetail.condition.orderNo}}</div>
        <el-table max-height="400" :data="tableDataDetail" :border="true"
        :header-cell-style="{background:'#f59a23',color:'#fff'}"
        >
     <el-table-column align="center" label="序号" type="index"></el-table-column>
    <el-table-column align="center" label="菜品名称" prop="productName"> </el-table-column>
     <el-table-column :show-overflow-tooltip="true" align="center" label="菜品类型" prop="categoryName"></el-table-column>
 <el-table-column :show-overflow-tooltip="true" align="center" label="报损数量" prop="num"></el-table-column>
 <el-table-column :show-overflow-tooltip="true" align="center" label="报损时间">
    <template slot-scope="scope">
        <span>{{scope.row.createDt | dataFormat}}</span>
    </template>
 </el-table-column>
 </el-table>
            <div>
                 <el-pagination
      @size-change="handleSizeChangeDetail"
      @current-change="handleCurrentChangeDetail"
      :current-page="queryInfoDetail.currPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="queryInfoDetail.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalDetail">
    </el-pagination>
            </div>
            </div>
        </el-card>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                totalList:0,
                totalDetail:0,
                queryInfo:{
                pageSize:10,
                currPage :1,
                condition:{
                merchantCode:localStorage.getItem('merchantCode'),
                type:'3'
                        }
                },
                queryInfoDetail:{
                  pageSize:10,
                  currPage:1,
                   condition:{
                    orderNo:'',
                    merchantCode:localStorage.getItem('merchantCode'),
                   }
                },
                dataRange:[],
                tableData:[],
                tableDataDetail:[]
            }
        },
        methods:{
            queryOne(row){
               this.queryInfoDetail.condition.orderNo=row.orderNo
               this.getDetail()
            },
           async getList(){
              let res=await  this.$http.post('merchantLossTransRecords/list',this.queryInfo)
              console.log(res)
              if(res.data.code==200){
                this.totalList=res.data.data.count
                this.tableData=res.data.data.data
              }else{
                this.$message.error(res.data.$message)
              }
            },
            async getDetail(){
              let res=await this.$http.post('merchantLossTransProduct/list',this.queryInfoDetail)
           this.totalDetail=res.data.data.count
           this.tableDataDetail=res.data.data.data
           },
            handleSizeChangeList(v){
                this.queryInfo.pageSize=v
                 this.getList()
            },
            handleCurrentChangeList(v){
                this.queryInfo.currPage=v
                 this.getList()
            },
              handleSizeChangeDetail(v){
                this.queryInfoDetail.pageSize=v
                 this.getDetail()
            },
            handleCurrentChangeDetail(v){
                this.queryInfoDetail.currPage=v
                 this.getDetail()
            }
        },
       async mounted(){
        await this.getList()
        console.log(this.tableData,'=====')
        if(this.tableData!=null && this.tableData.length!=0){
        this.queryInfoDetail.condition.orderNo=this.tableData[0].orderNo
       this.getDetail()
        }

        }
    }
</script>

<style lang="scss" scoped>
.two{
    margin-top: 12px;
    .head{
        font-size: 14px;
    }
}
.myBtn{
    background-color: #f59a23;
    color: #333;
    border-radius: 4px;
    border-color: #f59a23;
   height: 30px;
   padding: 0 14px;
}
.searchBtn{
   background-color: #f59a23;
    color: #333;
     transform: translateY(-2px);
     border-color: #f59a23;
    margin-left: 16px;
}
.resetBtn{
    background-color: #fff;
    color: #333;
    border-color: #dcdfe6;
    transform: translateY(-1px);
     margin-left: 14px;
}
/deep/ .myData{
    width: 330px;
    input{
        width: 126px;
    }
}
/deep/ .card{
    height: calc(100vh - 76px);
    overflow: auto;
}
/deep/ tr{
    height: 36px;
}
</style>